import { render, staticRenderFns } from "./knowledge-overview.vue?vue&type=template&id=055a6d98&scoped=true"
import script from "./knowledge-overview.vue?vue&type=script&lang=js"
export * from "./knowledge-overview.vue?vue&type=script&lang=js"
import style0 from "./knowledge-overview.vue?vue&type=style&index=0&id=055a6d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a6d98",
  null
  
)

export default component.exports